import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function useBlockedUsersQuery(options) {
  return useQuery(QUERY_CACHE_KEY.blockedUsers(), options);
}

export default useBlockedUsersQuery;
